import { render, staticRenderFns } from "./CreateSet.vue?vue&type=template&id=6236ecf0&"
import script from "./CreateSet.vue?vue&type=script&lang=js&"
export * from "./CreateSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports